module.exports = __webpack_public_path__ + "img/sak-logo-yellow.179e5cec.svg";